import { cn } from '@/lib/utils';

export const Page = ({ children, title, className, ...props }: { children: React.ReactNode, title: string, className?: string }) => {
  return (
    <main {...props} className={cn("p-4", className)}>
      <h1 className="text-2xl font-bold tracking-tight mb-4">{title}</h1>
      {children}
    </main>
  );
};